// Module
var code = "<div id=\"amap-container\"><div class=\"marker-container\" ng-transclude></div></div>";
// Exports
export default code;